module.exports = __webpack_public_path__ + "static/media/hk-logo.350591db.png";